function resolveUrl(url, baseUrl) {
	if (baseUrl) {
		return new URL(url, baseUrl).href;
	}

	return url;
}

export default resolveUrl;
